var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"currency-bar d-flex flex-wrap justify-content-end"},[(!_vm.hideBlackPearl)?_c('BlackPearlField',{staticClass:"ml-2 mb-2"}):_vm._e(),_c('QuartersField',{staticClass:"ml-2 mb-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }